import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8, -2)">
      <g transform="translate(11, 5)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M39.5,30.3 L44.5,30.3 L54.5,61 L49,61 L46.8,54.5 L37.2,54.5 L35,61 L29.5,61 L39.5,30.3 Z M42,36.8 L39.2,49.5 L44.8,49.5 L42,36.8 Z"
          fill="currentColor"
          transform="translate(-2.5, -1)"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
